// FORMATTERS ---------------------------------------------------------------- //

/** Format a 0-1 fraction as a percentage string. Returns '-' for nullish/non-finite values. */
export function formatPercent(value: number | null | undefined, digits = 0): string {
  if (value == null || !Number.isFinite(value)) return '-';
  const factor = Math.pow(10, digits);
  return `${Math.round(value * 100 * factor) / factor}%`;
}

/** Format a number with locale separators. Returns '-' for nullish/non-finite values. */
export function formatNumber(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '-';
  return new Intl.NumberFormat().format(value);
}

/** Format a mileage value with one decimal place. Returns '-' for nullish/non-finite values. */
export function formatMiles(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '-';
  return `${value.toFixed(1)} mi`;
}

/** Format a ratio (e.g. moves per driver) with one decimal place. Returns '-' for nullish/non-finite values. */
export function formatRatio(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '-';
  return value.toFixed(1);
}
